import React from "react";
import { useId } from "../../hooks/use-id";

/**
 * El componente Accesibility representa una sección de la página "Estándares Abiertos para Integraciones en EdTech" relacionada con la accesibilidad.
 * Renderiza un iframe que muestra contenido HTML específico para la accesibilidad.
 *
 * @component
 * @example
 * // Uso del componente Accesibility
 * <Accesibility />
 *
 * @returns {JSX.Element} - El componente Accesibility.
 */
export const Accesibility = () => {
    const titleId = useId('data-privacy-iframe-title');

    return (<section aria-labelledby={titleId} className="w-100 overflow-auto">
        <h3 id={titleId} className="sr-only">
            Accessibility WGCA Content
        </h3>
        <div className="w-100">
            <iframe
                className="w-100 onbackground-primary--bordered"
                src="/edtech/accessibility2026.html"
                title="Accessibility WGCA information for EdTech integrations"
                loading="lazy"
                style={{ minHeight: '600px', height: '80vh', border: '0' }}
            />
        </div>
        {/* Fallback accesible */}
        <p className="mt-2">
            If you can’t view the content, you can access it directly here:{" "}
            <a href="/edtech/accessibility2026.html" className="focusable-red">
                View accessibility WGCA
            </a>
        </p>
    </section>)
}